import {
  useDeleteMutation,
  useInsertMutation,
  useRevalidateTables,
  useUpdateMutation,
} from '@supabase-cache-helpers/postgrest-react-query';
import { useCallback } from 'react';

import { Unit } from '@/types';
import { supabaseClient } from '@/utils/supabase-client';

export function useCreateIngredient() {
  const revalidateTables = useRevalidateTables([
    { schema: 'public', table: 'ingredient' },
    { schema: 'public', table: 'ingredient_price' },
    { schema: 'public', table: 'ingredient_overview' },
  ]);

  return useCallback(
    async (
      organisation_id: string | undefined,
      supplier_id: string,
      ingredient_title: string,
      ingredient_code: string,
      default_mass_unit: Unit,
      default_volume_unit: Unit,
    ) => {
      const res = await supabaseClient.rpc('insert_ingredient', {
        supplier_id,
        ingredient_title,
        ingredient_code,
        default_mass_unit,
        default_volume_unit,
        organisation_id,
      });

      // Revalidate the ingredents, ingredient prices and latest ingredient prices tables
      await revalidateTables();

      return res;
    },
    [],
  );
}

export function useInsertIngredientPrice() {
  return useInsertMutation(
    supabaseClient.from('ingredient_price'),
    ['id'],
    '',
    {
      revalidateTables: [
        { table: 'ingredient_price' },
        { table: 'ingredient_overview' },
      ],
    },
  );
}

// TODO: Should this name be
export function useInsertIngredientAllergen() {
  return useInsertMutation(
    supabaseClient.from('ingredient_allergen'),
    ['id'],
    '',
    {
      revalidateTables: [
        { table: 'latest_ingredient_allergen' },
        { table: 'ingredient_overview' },
      ],
    },
  );
}

export function useInsertIngredientNutrients() {
  return useInsertMutation(
    supabaseClient.from('ingredient_nutrient'),
    ['id'],
    '',
    {
      revalidateTables: [
        { table: 'latest_ingredient_nutrient' },
        { table: 'ingredient_overview' },
      ],
    },
  );
}

export function useInsertIngredientQuantities() {
  return useInsertMutation(
    supabaseClient.from('ingredient_quantity'),
    ['id'],
    '',
    {
      revalidateTables: [
        { table: 'ingredient_quantity' },
        { table: 'ingredient_overview' },
      ],
    },
  );
}

export function useEditIngredientDetails() {
  return useUpdateMutation(supabaseClient.from('ingredient'), ['id'], '', {
    revalidateTables: [
      { table: 'ingredient' },
      { table: 'ingredient_overview' },
    ],
  });
}

export function useDeleteIngredient() {
  return useDeleteMutation(supabaseClient.from('ingredient'), ['id'], '', {
    revalidateTables: [
      { table: 'ingredient' },
      { table: 'ingredient_overview' },
      { table: 'ingredient_price' },
      { table: 'ingredient_quantity' },
      { table: 'ingredient_allergen' },
      { table: 'ingredient_nutrient' },
    ],
  });
}
